var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"questions"}},[_c('questions')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }